module.exports = __webpack_public_path__ + "static/media/logo.8df4fdc4.svg";